import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ShapePentagon = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M22 30H10C8.262 30 6.733 28.889 6.196 27.236C6.192 27.224 6.189 27.213 6.185 27.201L2.228 13.332C2.077 12.903 2 12.455 2 12C2 10.511 2.854 9.124 4.184 8.44C4.187 8.438 4.189 8.437 4.191 8.435L13.678 2.743C14.359 2.257 15.161 2 16 2C16.839 2 17.641 2.257 18.322 2.743L27.809 8.435C27.812 8.437 27.814 8.438 27.816 8.44C29.145 9.124 29.999 10.511 29.999 12C29.999 12.455 29.922 12.903 29.771 13.332L25.814 27.201C25.811 27.213 25.807 27.224 25.803 27.236C25.266 28.889 23.737 30 21.999 30H22ZM8.103 26.633C8.376 27.451 9.136 28 10 28H22C22.864 28 23.624 27.451 23.897 26.633L27.857 12.751C27.864 12.728 27.871 12.706 27.879 12.684C27.959 12.464 27.999 12.234 27.999 12C27.999 11.241 27.551 10.533 26.858 10.197C26.806 10.172 26.756 10.142 26.71 10.109L17.256 4.437C17.23 4.421 17.204 4.404 17.18 4.386C16.836 4.134 16.428 4 16 4C15.572 4 15.164 4.133 14.82 4.386C14.795 4.404 14.77 4.421 14.744 4.437L5.288 10.111C5.242 10.144 5.193 10.173 5.142 10.198C4.449 10.534 4.001 11.242 4.001 12.001C4.001 12.235 4.042 12.465 4.122 12.685C4.13 12.707 4.137 12.73 4.144 12.752L8.104 26.634L8.103 26.633Z" />
	</svg>
);

export default ShapePentagon;
